// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2Wr8f","ButtonAlt":"Button_ButtonAlt__2HJ85"};